import { cn } from '@/lib/utils'
import type { KnowledgeRetrievalTrace } from '@/types/contextObservability'
import { ScoreBadge } from '@/components/knowledge/ScoreBadge'
import { Badge } from '@/components/ui/badge'

export interface KBRetrievalsSectionProps {
  retrievals: KnowledgeRetrievalTrace[]
  className?: string
}

export function KBRetrievalsSection({ retrievals, className }: KBRetrievalsSectionProps) {
  if (retrievals.length === 0) return null

  return (
    <div className={cn('space-y-4', className)}>
      {retrievals.map((trace, idx) => (
        <div key={`${trace.toolName}-${idx}`} className="space-y-2">
          <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
            <span className="font-mono font-medium text-foreground">{trace.toolName}</span>
            <span className="text-border">·</span>
            <span className="truncate max-w-xs">"{trace.query}"</span>
            <span className="text-border">·</span>
            <span>{trace.resultCount} results</span>
            <span className="text-border">·</span>
            <span>{trace.queryTimeMs}ms</span>
          </div>

          <div className="space-y-1">
            {trace.results.map((result) => (
              <div
                key={result.chunkId}
                className="flex items-start gap-2 rounded-md border px-3 py-2 bg-background"
              >
                <ScoreBadge label="" score={result.relevanceScore} className="mt-0.5" />

                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{result.title}</div>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground mt-0.5">
                    <Badge variant="secondary" className="text-[10px] px-1.5 py-0">
                      {result.sourceType}
                    </Badge>
                    <span>{result.documentId}</span>
                    <span className="text-border">·</span>
                    <span>{result.contentPreviewLength} chars</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
